import moment from 'moment'
import numeral from 'numeral'
const calCsi = (value, vendorName) => {
  let count = 0
  let item = 0
  value &&
    value.map(list => {
      if (
        list.CSI_SCORE_AVG &&
        typeof Number &&
        list.VENDOR_NAME.toUpperCase() == vendorName.toUpperCase()
      ) {
        count += Number(list.CSI_SCORE_AVG)
        item++
      }
    })

  if (item > 0) {
    return Math.round(count / item)
  }
  return '-'
}
const spmScoringCategory = itemSpm => {
  if (itemSpm && itemSpm.length > 0) {
    let obj = {}
    let count = 0
    let total = 0

    itemSpm.map(list => {
      if (obj[list.PROJECT_NAME] === undefined) {
        obj[list.PROJECT_NAME] = {
          avg: list.AVG_GRADE ? [list.AVG_GRADE] : [],
        }
      } else {
        obj[list.PROJECT_NAME]['avg'] = list.AVG_GRADE
          ? [...obj[list.PROJECT_NAME]['avg'], list.AVG_GRADE]
          : obj[list.PROJECT_NAME]['avg']
      }
    })

    let newObj = Object.values(obj)
    newObj &&
      newObj.map(list => {
        count +=
          list.avg.reduce((a, b) => Number(a) + Number(b), 0) / list.avg.length
        total++
      })

    if (total > 0) return Math.round(count / total)
  }
  return '-'
}
export const sortPoType = newField => {
  newField = {
    ...newField,
    sortByFormatted: true,
    formatter: (value, key, item) => {
      let arr = []
      if (item) {
        const filterPoType = item.po.filter(
          list =>
            item.VENDOR_NAME.toUpperCase() == list.VENDOR_NAME.toUpperCase()
        )
        if (filterPoType && filterPoType.length > 0) {
          filterPoType.forEach(list => arr.push(list.PO_TYPE))
          const arrFilter = arr.filter((a, b) => arr.indexOf(a) == b).join(', ')
          return arrFilter
        }
        return '-'
      }
    },
  }
  return newField
}

export const sortCsiAdj = newField => {
  newField = {
    ...newField,
    sortByFormatted: true,
    formatter: (value, key, item) => {
      let itemCsi = item && item.csi
      if (itemCsi && itemCsi.length > 0) {
        if (Math.round(calCsi(itemCsi, item.VENDOR_NAME)) <= 1)
          return 'CSI Sangat Buruk'
        if (Math.round(calCsi(itemCsi, item.VENDOR_NAME)) == 2)
          return 'CSI Tidak Memuaskan'
        if (Math.round(calCsi(itemCsi, item.VENDOR_NAME)) == 3)
          return 'CSI Cukup Memuaskan'
        if (Math.round(calCsi(itemCsi, item.VENDOR_NAME)) == 4)
          return 'CSI Memuaskan'
        if (Math.round(calCsi(itemCsi, item.VENDOR_NAME)) == 5)
          return 'CSI Sangat Memuaskan'
      }
      return '-'
    },
  }
  return newField
}

export const sortCsiScore = newField => {
  newField = {
    ...newField,
    sortByFormatted: true,
    formatter: (value, key, item) => {
      let itemCsi = item && item.csi
      if (itemCsi && itemCsi.length > 0) {
        return calCsi(itemCsi, item.VENDOR_NAME)
      }
      return '-'
    },
  }
  return newField
}

export const sortEventAwarded = newField => {
  newField = {
    ...newField,
    sortByFormatted: true,
    formatter: (value, key, item) => {
      let event = item && item.EVENT
      if (event && event.length > 0) {
        const awarded = event && event.filter(list => list.EVENT_AWARDED > 0)
        return awarded.length
      }
      return 0
    },
  }
  return newField
}

export const sortEventParticipated = newField => {
  newField = {
    ...newField,
    sortByFormatted: true,
    formatter: (value, key, item) => {
      let event = item && item.EVENT
      if (event && event.length > 0) {
        const participated =
          event && event.filter(list => list.EVENT_PARTICIPATED > 0)
        return participated.length
      }
      return 0
    },
  }
  return newField
}

export const sortK3lRemaining = newField => {
  newField = {
    ...newField,
    sortByFormatted: true,
    formatter: (value, key, item) => {
      if (item) {
        const k3lEnd = new Date(item.K3L_PREQ_END_DATE)
        const convertTime = 1000 * 60 * 60 * 24
        if (
          k3lEnd &&
          (k3lEnd.getTime() - new Date().getTime()) / convertTime <= 60 &&
          (k3lEnd.getTime() - new Date().getTime()) / convertTime >= 0
        ) {
          return parseInt(
            (k3lEnd.getTime() - new Date().getTime()) / convertTime
          )
        }
        return '-'
      }
    },
  }
  return newField
}

export const sortPoValue = newField => {
  newField = {
    ...newField,
    sortByFormatted: true,
    formatter: (value, key, item) => {
      let count = 0
      let totalItem = 0
      let itemPo = item && item.po
      if (itemPo) {
        itemPo.map(list => {
          count += parseInt(list.TOTAL_VALUE_IDR)
          totalItem++
        })
        if (totalItem > 0) {
          let idr = numeral(parseInt(count)).format('0,0.00')
          let newIdr = ''
          idr.split('').map(list => {
            if (list == ',') {
              newIdr += '.'
            } else if (list == '.') {
              newIdr += ','
            } else {
              newIdr += list
            }
          })
          return count
        }
      }
      return 0
    },
  }
  return newField
}

export const sortRiskCategory = newField => {
  newField = {
    ...newField,
    sortByFormatted: true,
    formatter: (value, key, item) => {
      let score = item && item.SCORE_FOR_K3L_PREQUALIFICATION
      if (score && score > 0) {
        if (score <= 24) return 'LOW C2'
        if (score > 24 && score < 35) return 'LOW C1'
        if (score >= 35 && score < 50) return 'MEDIUM B2'
        if (score >= 50 && score < 70) return 'MEDIUM B1'
        if (score >= 70 && score <= 100) return 'HIGH'
      }
      return '-'
    },
  }
  return newField
}

export const sortSpmScoring = newField => {
  newField = {
    ...newField,
    sortByFormatted: true,
    formatter: (value, key, item) => {
      let itemSpm = item && item.SPM
      if (itemSpm && itemSpm.length > 0) {
        let obj = {}
        let count = 0
        let total = 0

        itemSpm.map(list => {
          if (obj[list.PROJECT_NAME] === undefined) {
            obj[list.PROJECT_NAME] = {
              avg: list.AVG_GRADE ? [list.AVG_GRADE] : [],
            }
          } else {
            obj[list.PROJECT_NAME]['avg'] = list.AVG_GRADE
              ? [...obj[list.PROJECT_NAME]['avg'], list.AVG_GRADE]
              : obj[list.PROJECT_NAME]['avg']
          }
        })

        let newObj = Object.values(obj)
        newObj &&
          newObj.map(list => {
            count +=
              list.avg.reduce((a, b) => Number(a) + Number(b), 0) /
              list.avg.length
            total++
          })

        if (total > 0) return Math.round(count / total)
      }
      return '-'
    },
  }
  return newField
}
export const sortVendorCategory = newField => {
  newField = {
    ...newField,
    sortByFormatted: true,
    formatter: (value, key, item) => {
      let score = item && item.SPM
      if (spmScoringCategory(score) >= 95) {
        return 'Sangat Memuaskan'
      } else if (
        spmScoringCategory(score) >= 80 &&
        spmScoringCategory(score) < 95
      ) {
        return 'Memuaskan'
      } else if (
        spmScoringCategory(score) >= 70 &&
        spmScoringCategory(score) < 80
      ) {
        return 'Cukup Memuaskan'
      } else if (
        spmScoringCategory(score) > 50 &&
        spmScoringCategory(score) <= 69
      ) {
        return 'Tidak Memuaskan'
      } else if (
        spmScoringCategory(score) >= 0 &&
        spmScoringCategory(score) <= 50
      ) {
        return 'Sangat Buruk'
      } else {
        return '-'
      }
    },
  }
  return newField
}

export const convertNumberDescimal = value => {
  if (value) {
    return Number(value).toFixed(1)
  }

  return 0
}

export const monthConverter = value => {
  switch (value) {
    case 1:
      return 'Jan'
      break
    case 2:
      return 'Feb'
      break
    case 3:
      return 'Mar'
      break
    case 4:
      return 'Apr'
      break
    case 5:
      return 'Mei'
      break
    case 6:
      return 'Jun'
      break
    case 7:
      return 'Jul'
      break
    case 8:
      return 'Agt'
      break
    case 9:
      return 'Sep'
      break
    case 10:
      return 'Okt'
      break
    case 11:
      return 'Nov'
      break
    case 12:
      return 'Des'
      break

    default:
      break
  }
}
